/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

/**
 * Specifies what kind of signature flow is needed for the request.
 */
export type SignInfo = {
    /**
     * Used in signature flow if present.
     */
    signId?: string;
    /**
     * * OPEN - request needs signature flow (signId is present).
     * * NONE - signature flow not needed.
     * * DONE - signature flow has been already done.
     * * BLOCKED - signature flow is blocked due to local security reasons.
     * * COSIGNING - ongoing signature flow for collective signing.
     * * UNKNOWN - signature flow not recognised by payment service.
     *
     */
    state: SignInfo.state;
};

export namespace SignInfo {

    /**
     * * OPEN - request needs signature flow (signId is present).
     * * NONE - signature flow not needed.
     * * DONE - signature flow has been already done.
     * * BLOCKED - signature flow is blocked due to local security reasons.
     * * COSIGNING - ongoing signature flow for collective signing.
     * * UNKNOWN - signature flow not recognised by payment service.
     *
     */
    export enum state {
        OPEN = 'OPEN',
        DONE = 'DONE',
        NONE = 'NONE',
        BLOCKED = 'BLOCKED',
        COSIGNING = 'COSIGNING',
        UNKNOWN = 'UNKNOWN',
    }


}

